/* ==========================================================================
   Admin User Guide Page
   Protected guide showing both pharmacy admin and provider sections
   ========================================================================== */

import { GuideContent } from '@/components/guide/GuideContent'

export function UserGuide() {
  return (
    <div className="p-6 sm:p-8">
      <div className="max-w-5xl">
        <div className="mb-8">
          <h1 className="font-serif text-3xl text-charcoal">User Guide</h1>
          <p className="text-gray-600 mt-2">
            Complete guide for pharmacy admins and providers
          </p>
        </div>
        <GuideContent role="both" />
      </div>
    </div>
  )
}
